import {
  Button,
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
} from "@material-ui/core";
import { useFormik } from "formik";
import { useState } from "react";
import { connect } from "react-redux";
// import { ActionHeader, FaqLink } from '..';
import en from "../../../lang/en-us";
import { NoteModals } from "../../../lib/NoteModals";
import TextInput from "../../../lib/TextField";
// import { sendPhoneOTP, sendMobileOTP, updateMobile } from '../../../store/actions/nct';
import { RootStateType } from "../../../store/reducers";
import { addDialCode, OTP_ACTIONS } from "../../../utils/constants";
import { isError, showHelperText } from "../../../utils/utilityFunctions";
import { nextScreen } from "./flow";
import * as yup from "yup";
import MobileRelationship from "./MobileRelationship";
import React from "react";
import { BackArrow } from "../UpdateNominee/SelectedFolios";

const { dashboard, common } = en;
const initialValues = {
  mobile: "",
  mobileRelationship: "",
};
const validationSchema = yup.object({
  mobile: yup
    .string()
    .required(common.errors.mobile.required)
    .matches(/^\d{10}$/, common.errors.mobile.regex)
    .length(10, common.errors.mobile.mobileLength),
  mobileRelationship: yup
    .string()
    .required(common.errors.relationship.mobileRequired),
  // .mobile(common.errors.email.regex),
});

function ChangeMobileNew(props: any) {
  const { mobile: existingMobile } = props;
  const mobileFormik = useFormik({
    initialValues,
    onSubmit: async ({ mobile, mobileRelationship }) => {
      const goTo = nextScreen(props.match.path);
      if (existingMobile.slice(3) === mobile) {
        alert(
          "New mobile number should not be same as registered mobile number"
        );
        mobileFormik.setFieldValue("mobile", "");
        return;
      }
      if (props?.location?.state?.isPhygitial) {
        props.history.push(
          "/new-transaction/nct-type/phygital/change-mobile-document",
          {
            mobile,
            mobileRelationship,
            ...(props?.location?.state || {}),
          }
        );
        return;
      }

      props.history.push(
        "/new-transaction/nct-type/digital/change-mobile-list",
        {
          mobile,
          mobileRelationship,
          ...(props?.location?.state || {}),
        }
      );

      //   try {
      //     const {
      //       images = [],
      //       action = OTP_ACTIONS.NEW_MOBILE_ONINE_OTP,
      //       flow,
      //     } = props.location.state || {};
      //     const { pan, pekrn } = props;
      // let res = await props.sendMobileOTP({
      //     mobile: addDialCode(mobile),
      //     pan,
      //     pekrn,
      //     action,
      // });
      // const routeStateParams = {
      //     mobile,
      //     mobileRelationship,
      //     ...(res || {}).body,
      //     onSuccessNavigationUrl: props?.location?.state?.onSuccessNavigationUrl || '',
      //     foliosToUpdate: props?.location?.state?.foliosToUpdate,
      //     success: true,
      //     images,
      //     action,
      // };

      // props.history.replace(goTo, routeStateParams);
      //   } catch (err: any) {
      //     alert(err.message);
      //   }
    },
    validationSchema,
  });

  const handleMobileChange = (event: any) => {
    const { target } = event;
    let { value } = target;
    value = value.replace(/\D/g, ""); // Remove non-digit characters
    if (value.length <= 10) {
      mobileFormik.setFieldValue("mobile", value);
      // Clear the error for mobile field if it was previously shown
      if (mobileFormik.touched.mobile && mobileFormik.errors.mobile) {
        mobileFormik.setFieldError("mobile", "");
      }
    }
  };

  return (
    <div className="curved-bg nct-layout" style={{ padding: 0 }}>
      <BackArrow history={props.history} />
      <div className="curved-bg-content">
        <img
          className="change-email-img"
          src="/images/change-email-img.png"
          alt="icon"
        />
        <div className="curved-bg-content-inner xs-alignment">
          <div className="curved-bg-content-inner-top change-email-top">
            <h3
              className="subheading"
              style={{
                marginBottom: "40px",
                marginTop: "10px",
                fontFamily: "OpenSans-SemiBold",
                //fontSize: "15px",
                // lineHeight: "18px",
                textAlign: "left",
                // color: " #4f4f4f",
              }}
            >
              {dashboard.ChangeMobile.newMobile.heading}
              {/* <span>{dashboard.ChangeMobile.newMobile.headingSpan}</span> */}
            </h3>
            <p style={{ marginLeft: 20 }}>
              {dashboard.ChangeMobile.newMobile.info}
            </p>
            <div
              className="email_container"
              style={{ display: "flex", margin: "20px" }}
            >
              <div>
                <label
                  style={{
                    fontFamily: "OpenSans-SemiBold",
                    fontSize: "15px",
                    lineHeight: "18px",
                    color: " #4f4f4f",
                  }}
                >
                  Enter New Mobile Number
                </label>
                <TextInput
                  hiddenLabel
                  variant="outlined"
                  error={isError(mobileFormik, "mobile")}
                  helperText={showHelperText(mobileFormik, "mobile")}
                  value={mobileFormik.values.mobile}
                  //onChange={mobileFormik.handleChange}
                  onChange={handleMobileChange}
                  placeholder="Enter Here"
                  name="mobile"
                  style={{ width: "90%" }}
                  className="email_text_input"
                />
              </div>
              <MobileRelationship
                mobileFormik={mobileFormik}
                customStyle={true}
              />
            </div>
          </div>
          {/* <FaqLink section={UPDATE_MOBILE} history={props.history} /> */}
        </div>
        <div
          className="curved-bg-content-inner-bottom nct-button"
          style={{ alignItems: "flex-start" }}
        >
          <Button
            // disabled={mobileFormik.values.mobile.trim().length < 10}
            onClick={mobileFormik.handleSubmit as any}
            className="customBtn"
          >
            {dashboard.changeEmail.buttonText}
          </Button>
        </div>
      </div>
    </div>
  );
}
export default connect(
  ({ authReducer, portfolio }: RootStateType) => ({
    ...authReducer,
    ...portfolio,
  }),
  {}
)(ChangeMobileNew);

// export default {};
